import React from 'react';
import Blogs from './Blogs';
import Carousel from './Carousel';
import History from './History';

const Home = () => {
    return (
        <div>
            <Carousel />
            <History />
            <Blogs />

            {/* video test */}
            {/* <iframe width="560" height="315" src="https://www.youtube.com/embed/4iXYGc9R9LA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> */}
        </div>
    );
};

export default Home;